export const checkAuth = () => {
  let userData = localStorage.getItem('user');

  if (userData === null) {
    return false;
  }
  if (!JSON.parse(localStorage.getItem('token'))) {
    return false;
  }
  
  let user = JSON.parse(userData);
  let lastLogDate = user.date;

  const date1 = new Date();
  const date2 = new Date(lastLogDate);
  const diffTime = Math.abs(date2 - date1);

  if (diffTime > 43200 * 1000) {
    //alert('Sua sessão expirou. Faça login novamente!');
    return false;
  }

  return true;
}

export const getToken = () =>
  JSON.parse(localStorage.getItem('user')) != null
    ? JSON.parse(localStorage.getItem('user')).token
    : null;
